import { Button, ButtonProps } from '@purpur/library';
import styled, { css } from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type FloatingButtonProps = { $shown?: 'desktop-only' | 'always' };

const FloatingButton = styled(Button).attrs<Partial<ButtonProps>>({
    iconOnly: true,
    variant: 'secondary',
    size: 'lg',
})<FloatingButtonProps>`
    position: absolute;
    top: 50%;
    z-index: 1000;
    ${({ $shown }) =>
        ($shown === 'desktop-only' &&
            css`
                display: none;
                ${purpurMedia('md')({ display: 'flex' })}
            `) ||
        css({ display: 'flex' })}}
`;
export const NavButtonBackward = styled(FloatingButton)`
    left: 0;
`;
export const NavButtonForward = styled(FloatingButton)`
    right: 0;
`;
